import ListActions from "modules/list/actions";

import { WorkloadRoleBindingSchema } from "utils/schemas";

export const ROLE_BINDINGS_MODULE = "clusterGroupRoleBindings";

export const roleBindingsListingActions = new ListActions({
  async fetchData({ namespaces = [], clusters = [] } = {}) {
    //TODO
    return { items: [] };
  },
  initialQuery: () => ({
    namespaces: [],
    clusters: [],
  }),
  schema: [WorkloadRoleBindingSchema],
});
